import React, { useCallback, useState } from 'react'
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material'
import { FormTemplatesGrid } from './form-templates-grid.component'
import makeStyles from '@mui/styles/makeStyles'
import { useFormContext } from 'react-hook-form'
import ListIcon from '@mui/icons-material/List'
import { SummaryTemplate, Template } from '@shared/types'

interface Props {
  requirementBaseID: number
}

export const FormSummaryTemplate = ({ requirementBaseID }: Props) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const { register, setValue, watch } = useFormContext()
  const summary = watch('summary')
  const selectedTemplate = watch('selectedTemplate')

  const handleToggleTemplates = useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  const handleSelectTemplate = useCallback(
    (template: Template | SummaryTemplate) => {
      setValue('summary', template.description)
      setIsOpen(false)
    },
    [setIsOpen]
  )

  return (
    <>
      <Grid>
        <FormControlLabel
          control={
            <Checkbox {...register('saveSummaryAsTemplate')} color="primary" />
          }
          label="Zapisz jako szablon"
          disabled={!summary}
        />
      </Grid>
      {isOpen && (
        <FormTemplatesGrid
          requirementBaseID={requirementBaseID}
          type="summary"
          onSelectTemplate={handleSelectTemplate}
        />
      )}
      <Grid container>
        <Grid item xs={8} className={classes.actionButtonsContainer}>
          <Button
            onClick={handleToggleTemplates}
            variant="text"
            color="primary"
            startIcon={<ListIcon />}
            disabled={!selectedTemplate}
          >
            {isOpen ? 'Zamknij szablony' : 'Szablony'}
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export const useStyles = makeStyles({
  actionButtonsContainer: {
    alignItems: 'center',
    display: 'flex',
  },
})
